<h2 mat-dialog-title class="dialog-header">{{'locker.product.details.title'|traduccion}}
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="dialog-content">

    <mat-card class="card">
        <mat-card-content class="info-list">
            <div appGridColumns [colsLg]="2" [colsMd]="1" [colsSm]="1" [colWidths]="[75, 25]">
                <form [formGroup]="form" class="container">

                    <mat-tab-group [formGroup]="form" (selectedIndexChange)="onTabChange($event)">

                        <mat-tab label="Información">
                            <mat-card>
                                <mat-card-title>Información básica</mat-card-title>
                                <mat-divider></mat-divider>

                                <div class="grid-2">
                                    <mat-form-field appearance="outline">
                                        <mat-label>Category</mat-label>
                                        <mat-select formControlName="categoryId">
                                            <mat-option *ngFor="let category of categories" [value]="category.id">{{category.code}}</mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>

                                <mat-form-field appearance="outline">
                                    <mat-label>{{'locker.box.details.form.channel'|traduccion}}</mat-label>
                                    <mat-select formControlName="channel">
                                        <mat-option value="ANY_CHANNEL">{{'ANY_CHANNEL'|traduccion}}</mat-option>
                                        <mat-option value="ONLINE_CHANNEL">{{'ONLINE_CHANNEL'|traduccion}}</mat-option>
                                        <mat-option value="IN_STORE_CHANNEL">{{'IN_STORE_CHANNEL'|traduccion}}</mat-option>
                                    </mat-select>
                                    <app-form-error [control]="form.get('channel')" ></app-form-error>
                                </mat-form-field>

                                <div style="display: flex; align-items: center; gap: 10px;">
                                    <mat-slide-toggle appearance="outline" formControlName="enabled">
                                            Activado
                                    </mat-slide-toggle>
                                </div>
                            </mat-card>
                        </mat-tab>

                        <mat-tab label="Precios">
                            <button mat-stroked-button color="primary" (click)="addPrice()">
                                Añadir modalidad
                            </button>

                            <div formArrayName="prices">
                                <mat-card *ngFor="let price of prices.controls; let i = index" [formGroupName]="i"
                                    class="price-card">

                                    <mat-card-title>Precio {{ i + 1 }}</mat-card-title>

                                    <div class="grid-3">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Cantidad (€)</mat-label>
                                            <input matInput type="number" formControlName="price"  min="0.01">
                                            <app-form-error [control]="price.get('price')" ></app-form-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>Periodo</mat-label>
                                            <input matInput type="number" formControlName="period" min="1">
                                            <app-form-error [control]="price.get('period')" ></app-form-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>Unidad</mat-label>
                                            <mat-select formControlName="unit">
                                                <mat-option value="TIME_DAY">{{'TIME_DAY'|traduccion}}</mat-option>
                                                <mat-option value="TIME_HOUR">{{'TIME_HOUR'|traduccion}}</mat-option>
                                                <mat-option value="TIME_MINUTE">{{'TIME_MINUTE'|traduccion}}</mat-option>
                                            </mat-select>
                                            <app-form-error [control]="price.get('unit')" ></app-form-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="grid-2">
                                        <mat-form-field appearance="outline">
                                            <mat-label>Mínimo</mat-label>
                                            <input matInput type="number" formControlName="minPeriod" min="0">
                                            <app-form-error [control]="price.get('minPeriod')" ></app-form-error>
                                        </mat-form-field>

                                        <mat-form-field appearance="outline">
                                            <mat-label>Máximo</mat-label>
                                            <input matInput type="number" formControlName="maxPeriod">
                                            <app-form-error [control]="price.get('maxPeriod')" ></app-form-error>
                                        </mat-form-field>

                                        <mat-slide-toggle formControlName="businessHours">
                                            BusinessHour
                                        </mat-slide-toggle>
                                    </div>

                                    <mat-radio-group formControlName="type">
                                        <mat-radio-button value="UNIQUE">UNIQUE</mat-radio-button>
                                        <mat-radio-button value="RECURRENT">RECURRENT</mat-radio-button>
                                    </mat-radio-group>

                                    <button mat-button color="warn" (click)="removePrice(i)">
                                        Eliminar
                                    </button>
                                </mat-card>
                            </div>
                        </mat-tab>

                        <mat-tab label="Descuentos">
                            <mat-card>
                                <mat-card-title>Descuentos aplicables</mat-card-title>

                                <mat-chip-list *ngIf="relatedDiscounts.length; else noDiscounts">
                                    <mat-chip color="primary" selected *ngFor="let discount of relatedDiscounts">
                                        {{ discountLabel(discount) }}
                                    </mat-chip>
                                </mat-chip-list>

                                <ng-template #noDiscounts>
                                    <p class="discounts-empty">No hay descuentos asociados a este producto.</p>
                                </ng-template>

                            </mat-card>
                        </mat-tab>

                    </mat-tab-group>

                </form>

                <mat-card>
                    <app-product-summary 
                        [categories]="categories"
                        [product]="form.value">
                    </app-product-summary>
                </mat-card>
            </div>
        </mat-card-content>
    </mat-card>

</mat-dialog-content>
<mat-dialog-actions class="dialog-footer">
    <button mat-raised-button color="primary" (click)="save()"
        [disabled]="form.invalid"><mat-icon>save</mat-icon>{{'Guardar'|traduccion}}</button>
    <button *ngIf="!isNew && !form.invalid" mat-raised-button color="warn"
        (click)="delete()"><mat-icon>delete</mat-icon>{{'Eliminar'|traduccion}}</button>
</mat-dialog-actions>
